import React from "react";
import { API_URL } from "../../constants/api";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  DCOP_SOURCE_SYSTEM,
  REQUEST_STATUS,
  SECTIONS,
  SHAREPOINT_SOURCE_SYSTEM,
  TOOLTIP_LABEL
} from "../../constants/appConstants";
import { setSPSToken, getSPSTokenData } from "../../constants/constants";
import uniqBy from "lodash/uniqBy";
import {
  IsSectionVisible,
  removeDuplicates,
  IsTenant,
  IsTenantAdmin,
  PaperComponent,
  sortArray,
  getToolTipText,
  IsAdmin,
  GetEnableProperty
} from "../../utils/helper";
import {
  apiBatchRequest,
  apiDelete,
  apiRequest
} from "../../utils/api_service";
import DownloadSSRSPopUp from "../common/button-download-popup";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Toolbar,
  Typography,
  Tooltip
} from "@material-ui/core";
import "./requests.less";
import AddUpdateIncident from "./addUpdateIncident";
import PaginationControlled from "../common/pagination/pagination";
import TableHeaderWithFilter from "../common/table-header-filter";
import { filterTableRows } from "../../utils/filtered";
import { getArrayIndex } from "../../utils/lodash";
import { downloadExcelReportByAPI } from "../../utils/downloading";
import { Incident_List } from "../../constants/ssrs_api";
import { convertIntoDDFormat } from "../../utils/generic";
import moment from "moment";
import { IoMdCloseCircleOutline } from "react-icons/io";
import orderBy from "lodash/orderBy";
import FilterOff from "../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ShowToast, toastType } from "../../utils/toast-service";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";

class HealthTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editableData: "",
      isShowColFilter: true,
      isOpenAddUpdate: false,
      pageNo: 0,
      urlIncidentId: "",
      rowsPerPagination: 25,
      colFilteredObj: [],
      sortByColKey: "incidentId",
      incidentList: [],
      title: "",
      getToolTip: [],
      reload: false,
      selectedSource: [],
      selectedIds: {},
      refreshFilteredObj: false,
      clearData: false,
      reasonForDelete: "",
      isOpenDeleteConfirmationPanel: false
    };
  }

  /**
   * fetch data
   */
  componentDidMount() {
    const URLsearch = window.location.search;
    if (URLsearch && URLsearch.indexOf("incidentId") !== -1) {
      this.setState({
        urlIncidentId: atob(URLsearch.split("=")[1]),
        isOpenAddUpdate: true
      });
    }
    //fetch list data
    this.getMasterData();
    // this.getIncidentList();
    this.getTokenSpsData();
  }

  /**
   * call method when click on refresh button
   */
  resetPage = () => {
    this.getIncidentList();
  };

  /**
   * get share point token
   */
  getTokenSpsData = () => {
    if (!getSPSTokenData()) {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
        }
      });
    }
  };

  /**
   * get all master data
   */
  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.healthSafety.getIncidentMasterData,
        key: "incidentMasterData"
      },
      {
        url: API_URL.healthSafety.getIncidentList,
        key: "incidentList",
        params: { DateOffset: moment().utcOffset() }
      },
      {
        url: API_URL.masterData.GetLabels,
        key: "getToolTip",
        params: { sectionId: SECTIONS.HSE_INCIDENT_MENU }
      }
    ]).then(({ incidentMasterData, incidentList, getToolTip }) => {
      const categoryMasterData = incidentMasterData?.data
        .filter(x => x.Key === "Category")
        .map(y => {
          return {
            categoryTypeId: y.Value,
            categoryType: y.Label,
            id: y.Value
          };
        });
      const subCategoryMasterData = incidentMasterData?.data
        .filter(x => x.Key === "SubCategory")
        .map(y => {
          return {
            SubCategoryId: y.Value,
            SubCategory: y.Label,
            id: y.Value
          };
        });
      const contributingFactorMasterData = incidentMasterData?.data
        .filter(x => x.Key === "ContributingFactor")
        .map(y => {
          return {
            ContributingFactorId: y.Value,
            ContributingFactor: y.Label,
            id: y.Value
          };
        });
      const projectMasterData = incidentMasterData?.data
        .filter(x => x.Key === "Project")
        .map(y => {
          return {
            ProjectId: y.Value,
            Project: y.Label,
            id: y.Value
          };
        });
      const dataCenterMasterData = incidentMasterData?.data
        .filter(x => x.Key === "DataCenter")
        .map(y => {
          return {
            DataCenterId: y.Value,
            DataCenter: y.Label,
            id: y.Value
          };
        });

      const statusMasterData = incidentMasterData?.data
        .filter(x => x.Key === "IncidentStatus")
        .map(y => {
          return {
            IncidentStatusId: y.Value,
            IncidentStatus: y.Label
          };
        });

      // filter the source system master data
      const sourceSystemMasterData = incidentMasterData?.data
        .filter(x => x.Key === "SourceSystem")
        .map(y => {
          return {
            SourceSystemId: y.Value,
            SourceSystem: y.Label
          };
        });

      this.setState({
        incidentList: incidentList?.data,
        categoryMasterData,
        subCategoryMasterData,
        contributingFactorMasterData,
        projectMasterData,
        dataCenterMasterData,
        statusMasterData,
        getToolTip: getToolTip?.data,
        sourceSystemMasterData
      });
    });
  };

  /**
   * get all hse record
   */
  getIncidentList = () => {
    apiRequest({
      url: API_URL.healthSafety.getIncidentList,
      params: { DateOffset: moment().utcOffset() }
    }).then(({ data: List }) => {
      this.setState({
        incidentList: List
      });
    });
  };

  /**
   * call on save button
   */
  onSave = () => {
    const { reload, colFilteredObj } = this.state;
    this.setState({
      isOpenAddUpdate: false,
      keepFilterData: true,
      reload: !reload,
      clearData: false,
      sortByColKey: "",
      selectedSource: colFilteredObj
    });
    this.getIncidentList();
  };

  /**
   * call on edit button
   * @param {*} isOpen
   * @param {*} editRow
   */
  onEditClicked = (isOpen = false, editRow = "") => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: editRow
    });
  };

  /**
   * call on add button
   * @param {*} isOpen
   */
  onAddButtonClicked = (isOpen = false) => {
    this.setState({
      isOpenAddUpdate: isOpen,
      editableData: ""
    });
  };

  /**
   * set state values
   * @param {*} key
   * @param {*} value
   */
  setStateVal = (key, value) => {
    this.setState({ [key]: value });
  };

  /**
   * refresh incident list
   * @param {*} isCalledGet
   */
  refreshIncident = (isCalledGet = true) => {
    const { reload, colFilteredObj } = this.state;

    this.clearSearchRequestId();
    this.setState({
      isOpenAddUpdate: false,
      editableData: "",
      keepFilterData: true,
      reload: !reload,
      selectedSource: colFilteredObj,
      clearData: false,
      sortByColKey: ""
    });
    isCalledGet && this.getIncidentList();
  };

  /**
   * update row count
   * @param {*} pageNo
   * @param {*} rowsPerPagination
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    window.scrollTo(0, 0);
    this.setState({ pageNo, rowsPerPagination });
  };

  /**
   * clear search
   */
  clearSearchRequestId = () => {
    this.props.history.replace({
      search: ""
    });
  };

  /**
   * get filtered data
   * @param {*} data
   * @returns
   */
  getFilteredData = data => {
    const { colFilteredObj, sortByColKey } = this.state;
    const fData = orderBy(
      filterTableRows(data, colFilteredObj, "observationDate"),
      x => x[sortByColKey],
      "desc"
    );

    return fData || [];
  };

  /**
   * update column filter
   * @param {*} key
   * @param {*} value
   * @param {*} filterType
   */
  updateColumnFilter = (key, value = "", filterType) => {
    const { colFilteredObj, selectedIds } = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    }
  };

  /**
   * Download SSRS report
   * @param {*} report
   * @param {*} type
   */
  downloadSSRSReport = (report, type = "excel") => {
    const {
      colFilteredObj,
      dataCenterMasterData,
      categoryMasterData,
      subCategoryMasterData,
      projectMasterData,
      statusMasterData,
      sourceSystemMasterData
    } = this.state;
    const incidentCode =
      colFilteredObj.filter(f => f.keyName == "incidentCode")[0]?.value ||
      "All";
    const dataCenterName =
      colFilteredObj.filter(f => f.keyName == "dataCenterName")[0]?.value ||
      "All";
    const categoryName =
      colFilteredObj.filter(f => f.keyName == "categoryName")[0]?.value ||
      "All";
    const subCategoryName =
      colFilteredObj.filter(f => f.keyName == "subCategoryName")[0]?.value ||
      "All";
    const observedBy =
      colFilteredObj.filter(f => f.keyName == "observedBy")[0]?.value || "All";
    const projectName =
      colFilteredObj.filter(f => f.keyName == "projectName")[0]?.value || "All";

    const status =
      colFilteredObj.filter(f => f.keyName == "incidentStatus")[0]?.value ||
      "All";

    // get source system selected value
    const sourceSystem =
      colFilteredObj.filter(f => f.keyName == "sourceSystem")[0]?.value ||
      "All";

    const observationDateFilter = colFilteredObj.filter(
      f => f.keyName == "observationDate"
    )[0]?.value;
    const createdDateFilter = colFilteredObj.filter(
      f => f.keyName == "createdDate"
    )[0]?.value;

    let observationFrom = "IsNull=True";
    let observationTo = "IsNull=True";
    let createdFromDate = "IsNull=True";
    let createdTo = "IsNull=True";
    const attachment =
      colFilteredObj
        .filter(f => f.keyName == "attachment")[0]
        ?.value.toString() || "All";
    const attachmentLength =
      attachment.split(",").length == 3 ? "All" : attachment;

    if (observationDateFilter && observationDateFilter.length > 0) {
      [observationFrom, observationTo] = observationDateFilter.split("-");
    }

    if (createdDateFilter && createdDateFilter.length > 0) {
      [createdFromDate, createdTo] = createdDateFilter.split("-");
    }
    const dateOffset = moment().utcOffset();

    let dataCenterId = [];
    let categoryId = [];
    let subCategoryId = [];
    let projectId = [];
    let statusId = [];
    let sourceSystemId = [];

    if (dataCenterName !== "All") {
      dataCenterName.forEach(x => {
        if (x == "All") {
          dataCenterId = [];
          return;
        } else {
          dataCenterId.push(
            dataCenterMasterData.find(y => y.DataCenter === x)?.DataCenterId
          );
        }
      });
    }

    if (categoryName !== "All") {
      categoryName.forEach(x => {
        if (x == "All") {
          categoryId = [];
          return;
        } else {
          categoryId.push(
            categoryMasterData.find(y => y.categoryType === x)?.categoryTypeId
          );
        }
      });
    }

    if (subCategoryName !== "All") {
      subCategoryName.forEach(x => {
        if (x == "All") {
          subCategoryId = [];
          return;
        } else {
          subCategoryId.push(
            subCategoryMasterData.find(y => y.SubCategory === x)?.SubCategoryId
          );
        }
      });
    }

    if (projectName !== "All") {
      projectName.forEach(x => {
        if (x == "All") {
          projectId = [];
          return;
        } else {
          projectId.push(
            projectMasterData.find(y => y.Project === x)?.ProjectId
          );
        }
      });
    }

    if (status !== "All") {
      status.forEach(x => {
        if (x == "All") {
          statusId = [];
          return;
        } else {
          statusId.push(
            statusMasterData.find(y => y.IncidentStatus === x)?.IncidentStatusId
          );
        }
      });
    }

    // get source system id
    if (sourceSystem !== "All") {
      sourceSystem.forEach(x => {
        if (x == "All") {
          sourceSystemId = [];
          return;
        } else {
          sourceSystemId.push(
            sourceSystemMasterData.find(y => y.SourceSystem === x)
              ?.SourceSystemId
          );
        }
      });
    }

    const param =
      "&IncidentCode=" +
      incidentCode +
      "&CategoryId=" +
      (categoryId.length === 0 ? "All" : categoryId.join(",")) +
      "&SubCategoryId=" +
      (subCategoryId.length === 0 ? "All" : subCategoryId.join(",")) +
      "&ObservedBy=" +
      (observedBy == null || observedBy == undefined ? "All" : observedBy) +
      "&ProjectId=" +
      (projectId.length === 0 ? "All" : projectId.join(",")) +
      "&Attachment=" +
      attachmentLength +
      "&DataCenterId=" +
      (dataCenterId.length === 0 ? "All" : dataCenterId.join(",")) +
      (observationFrom == "IsNull=True"
        ? "&ObservationFromDate:"
        : "&ObservationFromDate=") +
      observationFrom +
      (observationTo == "IsNull=True"
        ? "&ObservationToDate:"
        : "&ObservationToDate=") +
      observationTo +
      (createdFromDate == "IsNull=True"
        ? "&CreatedFromDate:"
        : "&CreatedFromDate=") +
      createdFromDate +
      (createdTo == "IsNull=True" ? "&CreatedToDate:" : "&CreatedToDate=") +
      createdTo +
      "&DateOffset=" +
      dateOffset +
      "&IncidentStatusId=" +
      (statusId.length === 0 ? "All" : statusId.join(",")) +
      "&SourceSystemId=" +
      (sourceSystemId?.length === 0 ? "All" : sourceSystemId.join(","));

    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }
  };

  /**
   * view all data
   * @param {*} viewAll
   * @param {*} dataCenters
   * @param {*} title
   */
  handleViewAllDataCenter = (viewAll = false, dataCenters, title = "") => {
    this.setState({
      viewAllDataCenter: viewAll,
      selectedDataCenters: dataCenters,
      title
    });
  };

  /**
   * clear filters
   */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;
    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {}
    });
  };

  /**
   * check edit icon visibility
   * @param {*} item
   * @returns
   */
  isEditIconVisible = item => {
    return (
      (item.sourceSystemId === DCOP_SOURCE_SYSTEM &&
        IsSectionVisible(
          SECTIONS.HSE_INCIDENT_MENU,
          SECTIONS.HSE_INCIDENT_CREATE,
          SECTIONS.ADD_EDIT
        )) ||
      (item.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
        IsSectionVisible(
          SECTIONS.HSE_INCIDENT_MENU,
          SECTIONS.EVENT_NOTIFICATION,
          SECTIONS.ADD_EDIT
        )) ||
      IsSectionVisible(
        SECTIONS.HSE_INCIDENT_MENU,
        SECTIONS.UPDATE_HSE,
        SECTIONS.ADD_EDIT
      )
    );
  };

  /**
   * set value of reason
   * @param {*} e
   */
  handleChange = e => {
    this.setState({
      reasonForDelete: e.target.value || ""
    });
  };

  /**
   * delete confirmation panel
   * @param {*} requestId
   */
  openDeleteConfirmationPanel = (isOpen, incidentId, propertyId) => {
    this.setState({
      incidentId: incidentId,
      propertyId: propertyId,
      isOpenDeleteConfirmationPanel: isOpen
    });
  };

  /**
   * delete hse observation record
   * @param {*} res
   */
  deleteHSEObservation = res => {
    if (res == true) {
      const {
        incidentId,
        propertyId,
        reasonForDelete,
        getToolTip
      } = this.state;
      if (reasonForDelete && reasonForDelete?.trim().length > 0) {
        apiDelete({
          url:
            API_URL.healthSafety.DeleteHSEObservation +
            "?incidentId=" +
            incidentId +
            "&propertyId=" +
            propertyId +
            "&reasonForDelete=" +
            reasonForDelete
        }).then(response => {
          response.success == false
            ? ShowToast(
                "Server Error: Unable to delete HSE Observation.",
                toastType.ERROR,
                5000,
                500
              )
            : ShowToast(
                "HSE Observation has been deleted successfully.",
                toastType.SUCCESS,
                5000,
                200
              );
          this.setState(
            {
              isOpenDeleteConfirmationPanel: false,
              reasonForDelete: false,
              incidentId: 0,
              propertyId: 0
            },
            () => {
              this.getIncidentList();
            }
          );
        });
      } else {
        ShowToast(
          getToolTipText(getToolTip, TOOLTIP_LABEL.REASON_FOR_DELETE) +
            " is required.",
          toastType.ERROR,
          5000,
          500
        );
      }
    } else {
      this.setState({
        isOpenDeleteConfirmationPanel: false,
        reasonForDelete: "",
        incidentId: 0,
        propertyId: 0
      });
    }
  };

  render() {
    const isTenant = IsTenant();
    const isTenantAdmin = IsTenantAdmin();

    const {
      editableData,
      isShowColFilter,
      isOpenAddUpdate,
      urlIncidentId,
      colFilteredObj,
      incidentList,
      categoryMasterData,
      subCategoryMasterData,
      contributingFactorMasterData,
      projectMasterData,
      dataCenterMasterData,
      statusMasterData,
      sourceSystemMasterData,
      getToolTip,
      isOpenDeleteConfirmationPanel,
      reasonForDelete,
      refreshFilteredObj,
      clearData,
      selectedIds,
      reload,
      keepFilterData,
      selectedSource,
      pageNo,
      rowsPerPagination,
      viewAllDataCenter,
      title,
      selectedDataCenters
    } = this.state;

    const addObservationVisible = IsSectionVisible(
      SECTIONS.HSE_INCIDENT_MENU,
      SECTIONS.HSE_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    const incidentFilterData = isShowColFilter
      ? this.getFilteredData(incidentList)
      : incidentList;

    const optionsListForCategory = uniqBy(
      convertIntoDDFormat(
        categoryMasterData || [],
        "categoryType",
        "categoryType"
      ),
      x => x.id
    );

    const optionsListForSubCategory = uniqBy(
      convertIntoDDFormat(
        subCategoryMasterData || [],
        "SubCategory",
        "SubCategory"
      ),
      x => x.id
    );

   
    const dataCenterData =  GetEnableProperty((dataCenterMasterData || []), SECTIONS.HSE_INCIDENT_LIST, "DataCenterId");

    const optionsListForDataCenter = uniqBy(
      convertIntoDDFormat(
        dataCenterData || [],
        "DataCenter",
        "DataCenter"
      ),
      x => x.id
    );


    const optionsListForProject = uniqBy(
      convertIntoDDFormat(projectMasterData || [], "Project", "Project"),
      x => x.id
    );

    const optionsListForStatus = uniqBy(
      convertIntoDDFormat(
        statusMasterData || [],
        "IncidentStatus",
        "IncidentStatus"
      ),
      x => x.id
    );

    // to get source system master data
    const optionsListForSourceSystem = uniqBy(
      convertIntoDDFormat(
        sourceSystemMasterData || [],
        "SourceSystem",
        "SourceSystem"
      ),
      x => x.id
    );

    return (
      <div className={"col-xs-12"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className={"requests-wrapper"}>
              <div className={"requests-breadcrumb-wrapper"}>
                <div className={"requests-breadcrumb"}>
                  {"HOME | "}
                  <span>{"HSE Observation"}</span>
                  {isOpenAddUpdate && editableData == "" && urlIncidentId == ""
                    ? " | Create Observation"
                    : ""}
                  {addObservationVisible === false &&
                  editableData &&
                  editableData != ""
                    ? " | View Observation"
                    : (editableData && editableData != "") ||
                      urlIncidentId !== ""
                    ? " | Edit Observation"
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isOpenAddUpdate ? (
          categoryMasterData &&
          subCategoryMasterData &&
          contributingFactorMasterData &&
          projectMasterData &&
          dataCenterMasterData && (
            <AddUpdateIncident
              categoryMasterData={categoryMasterData}
              subCategoryMasterData={subCategoryMasterData}
              contributingFactorMasterData={contributingFactorMasterData}
              projectMasterData={projectMasterData}
              dataCenterMasterData={dataCenterMasterData}
              incidentId={
                editableData ? editableData.incidentId : urlIncidentId
              }
              propertyId={editableData ? editableData.propertyId : 0}
              setStateVal={this.onEditClicked}
              onSave={this.onSave}
              refreshIncident={this.refreshIncident}
            />
          )
        ) : (
          <>
            <div className={"row"}>
              <div className={"col-xs-10"} style={{ display: "flex" }}>
                {addObservationVisible && (
                  <Button
                    variant={"contained"}
                    size={"small"}
                    onClick={() => this.onAddButtonClicked(true)}
                    style={{ height: "32px" }}
                  >
                    {"Create Observation\r"}
                  </Button>
                )}
                <FormControlLabel
                  className={"show-filter"}
                  control={
                    <Checkbox
                      id={"filterCompletedOrCancelled"}
                      color={"primary"}
                      defaultValue={isShowColFilter}
                      checked={isShowColFilter}
                      onChange={event =>
                        this.setState({
                          isShowColFilter: event.target.checked,
                          colFilteredObj: [],
                          clearData: true,
                          refreshFilteredObj: !refreshFilteredObj,
                          sortByColKey: "",
                          selectedIds: {}
                        })}
                    />
                  }
                  label={"Show Filters"}
                />
                <DownloadSSRSPopUp
                  buttonLabel={"Print"}
                  dataTip={getToolTipText(getToolTip, TOOLTIP_LABEL.DOWNLOAD)}
                  reportList={[
                    {
                      label: "Observation List",
                      id: 1,
                      pdfDownload: true,
                      excelDownload: true,
                      downloadLink: Incident_List
                    }
                  ]}
                  downloadBtnLabel={"Download"}
                  downloadReport={this.downloadSSRSReport}
                />
                <Tooltip
                  title={getToolTipText(getToolTip, TOOLTIP_LABEL.CLEAR_FILTER)}
                  placement={"bottom"}
                >
                  <img
                    className={"icons"}
                    src={FilterOff}
                    alt={"logo"}
                    onClick={() => {
                      this.clearFilter();
                    }}
                  />
                </Tooltip>
              </div>
              <div className={"col-xs-2 end-xs"}>
                <Tooltip
                  title={getToolTipText(getToolTip, TOOLTIP_LABEL.REFRESH)}
                  placement={"bottom"}
                >
                  <IconButton size={"small"} onClick={() => this.resetPage()}>
                    <RefreshIcon
                      style={{
                        fill: "#365E7E",
                        marginTop: "7px",
                        width: "28px",
                        height: "30px"
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <div className={"row content"} />
            <div className={"request-list-table-div"}>
              {incidentFilterData ? (
                <table
                  className={"request-list-table"}
                  style={{ fontWeight: "200 !important" }}
                >
                  <thead>
                    <tr
                      className={"blue-cust-title"}
                      style={{ borderTop: "3px solid #FFFFFF" }}
                    >
                      <th
                        colSpan={13}
                        style={{
                          fontSize: "15px",
                          textAlign: "center",
                          lineHeight: "25px"
                        }}
                      >
                        {"HSE Observations\r"}
                      </th>
                    </tr>
                    <TableHeaderWithFilter
                      clearData={clearData}
                      refreshFilteredObj={refreshFilteredObj}
                      selectedId={selectedIds}
                      reload={reload}
                      keepFilterData={keepFilterData}
                      selectedSource={selectedSource}
                      columnData={[
                        {
                          headerClass: "w-16",
                          colName: "Observation #",
                          keyName: "incidentCode"
                        },
                        {
                          headerClass: "w-10",
                          colName: "Data Center",
                          keyName: "dataCenterName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.dataCenterName,
                          optionsList: optionsListForDataCenter
                        },
                        {
                          headerClass: "w-15",
                          colName: "Observation Date",
                          keyName: "observationDate",
                          filterType: "dateRange"
                        },
                        {
                          headerClass: "w-15",
                          colName: "Category",
                          keyName: "categoryName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.categoryName,
                          optionsList: optionsListForCategory
                        },
                        {
                          headerClass: "w-5",
                          width: "80px",
                          colName: "Sub Category",
                          filterType: "multiSelect",
                          keyName: "subCategoryName",
                          selectedIds: colFilteredObj.subCategoryName,
                          optionsList: optionsListForSubCategory
                        },

                        {
                          headerClass: "w-10",
                          width: "68px",
                          colName: "Project",
                          keyName: "projectName",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.projectName,
                          optionsList: optionsListForProject
                        },
                        {
                          headerClass: "w-10",
                          colName: "Created Date",
                          keyName: "createdDate",
                          filterType: "dateRange"
                        },
                        {
                          headerClass: "w-15",
                          colName: "Created By",
                          keyName: "observedBy"
                        },
                        {
                          headerClass: "w-5",
                          width: "68px",
                          colName: "Status",
                          keyName: "incidentStatus",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.incidentStatus,
                          optionsList: optionsListForStatus
                        },
                        {
                          headerClass: "w-5",
                          width: "70px",
                          colName: "Attachment",
                          keyName: "attachment",
                          filterType: "multiSelect",
                          optionsList: [
                            { id: "No", value: "No" },
                            { id: "Yes", value: "Yes" }
                          ]
                        },
                        {
                          headerClass: "w-10",
                          width: "68px",
                          colName: "Source System",
                          keyName: "sourceSystem",
                          filterType: "multiSelect",
                          selectedIds: colFilteredObj.sourceSystem,
                          optionsList: optionsListForSourceSystem
                        },
                        {
                          headerClass: "w-25",
                          colName: "Action",
                          isHideFilter: true
                        }
                      ]}
                      isShowFilter={isShowColFilter}
                      onChangeFilter={this.updateColumnFilter}
                    />
                  </thead>

                  <tbody>
                    {incidentFilterData && incidentFilterData.length > 0 ? (
                      (
                        (rowsPerPagination > 0
                          ? incidentFilterData.slice(
                              pageNo * rowsPerPagination,
                              pageNo * rowsPerPagination + rowsPerPagination
                            )
                          : incidentFilterData) || []
                      ).map((item, index) => (
                        <tr key={"observation" + index}>
                          <td>
                            {item.incidentCode == null
                              ? "-"
                              : item.incidentCode}
                          </td>
                          <td>
                            {item.dataCenterName == null
                              ? "-"
                              : item.dataCenterName}
                          </td>
                          <td>
                            {item.observationDate == null
                              ? "-"
                              : moment(item.observationDate).format(
                                  "MM/DD/YYYY"
                                )}
                          </td>
                          <td>
                            {item.categoryName == null
                              ? "-"
                              : removeDuplicates(
                                  item.categoryName.split(",")
                                )?.map((obj, index) => (
                                  <Chip
                                    className={"chip"}
                                    key={"chip" + index + "c"}
                                    label={obj}
                                    style={{
                                      margin: 1,
                                      fontSize: "0.7rem",
                                      height: "1.8rem"
                                    }}
                                  />
                                ))}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {item.subCategoryName == null ? (
                              "-"
                            ) : (
                              <>
                                <span
                                  className={"underline"}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "0.7rem"
                                  }}
                                  onClick={() =>
                                    this.handleViewAllDataCenter(
                                      true,
                                      item.subCategoryName,
                                      "Sub Category"
                                    )}
                                >
                                  {
                                    removeDuplicates(
                                      item.subCategoryName.split(",")
                                    ).length
                                  }
                                </span>
                              </>
                            )}
                          </td>

                          <td>
                            {item.projectName == null ? "-" : item.projectName}
                          </td>
                          <td>
                            {moment(item.createdDate).format("MM/DD/YYYY")}
                          </td>
                          <td>
                            {item.observedBy == null ? "-" : item.observedBy}
                          </td>
                          <td>
                            {item.incidentStatus == null
                              ? "-"
                              : item.incidentStatus}
                          </td>
                          <td>
                            {item.attachment == null ? "-" : item.attachment}
                          </td>
                          <td>
                            {item.sourceSystem == null
                              ? "-"
                              : item.sourceSystem}
                          </td>
                          {(isTenantAdmin || !isTenant) &&
                          item.requestStatusId > REQUEST_STATUS.DRAFT ? (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={getToolTipText(
                                    getToolTip,
                                    TOOLTIP_LABEL.VIEW
                                  )}
                                  placement={"bottom"}
                                >
                                  <IconButton
                                    size={"small"}
                                    onClick={() =>
                                      this.onEditClicked(true, item)}
                                  >
                                    <VisibilityIcon
                                      fontSize={"small"}
                                      size={"small"}
                                    />
                                  </IconButton>
                                </Tooltip>
                                {item.sourceSystemId === DCOP_SOURCE_SYSTEM &&
                                  IsAdmin() && (
                                    <Tooltip
                                      title={getToolTipText(
                                        getToolTip?.filter(
                                          x => x.LabelType === "Tooltip"
                                        ) || [],
                                        TOOLTIP_LABEL.DELETE
                                      )}
                                      placement={"bottom"}
                                    >
                                      <IconButton
                                        size={"small"}
                                        onClick={() =>
                                          this.openDeleteConfirmationPanel(
                                            true,
                                            item.incidentId,
                                            item.propertyId
                                          )}
                                      >
                                        <DeleteIcon
                                          fontSize={"small"}
                                          size={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </span>
                            </td>
                          ) : (
                            <td>
                              <span style={{ display: "flex" }}>
                                <Tooltip
                                  title={
                                    this.isEditIconVisible(item)
                                      ? getToolTipText(
                                          getToolTip,
                                          TOOLTIP_LABEL.EDIT
                                        )
                                      : getToolTipText(
                                          getToolTip,
                                          TOOLTIP_LABEL.VIEW
                                        )
                                  }
                                >
                                  <IconButton
                                    size={"small"}
                                    onClick={() =>
                                      this.onEditClicked(true, item)}
                                  >
                                    {this.isEditIconVisible(item) ? (
                                      <EditIcon
                                        fontSize={"small"}
                                        size={"small"}
                                      />
                                    ) : (
                                      <VisibilityIcon
                                        fontSize={"small"}
                                        size={"small"}
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </IconButton>
                                </Tooltip>
                                {item.sourceSystemId === DCOP_SOURCE_SYSTEM &&
                                  IsAdmin() && (
                                    <Tooltip
                                      title={getToolTipText(
                                        getToolTip?.filter(
                                          x => x.LabelType === "Tooltip"
                                        ) || [],
                                        TOOLTIP_LABEL.DELETE
                                      )}
                                      placement={"bottom"}
                                    >
                                      <IconButton
                                        size={"small"}
                                        onClick={() =>
                                          this.openDeleteConfirmationPanel(
                                            true,
                                            item.incidentId,
                                            item.propertyId
                                          )}
                                      >
                                        <DeleteIcon
                                          fontSize={"small"}
                                          size={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </span>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ textAlign: "center" }} colSpan={9}>
                          {"No data available\r"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                ""
              )}
            </div>
            {incidentFilterData && incidentFilterData.length > 0 && (
              <div className={"paginationContainer"}>
                <PaginationControlled
                  tableLength={incidentFilterData.length}
                  updateRowCount={this.updateRowCount}
                  pageNo={pageNo}
                  rowsPerPagination={rowsPerPagination}
                />
              </div>
            )}
          </>
        )}
        <Dialog
          open={viewAllDataCenter || false}
          onClose={() => this.handleViewAllDataCenter(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {title}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.handleViewAllDataCenter(false, "")}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedDataCenters &&
              sortArray(removeDuplicates(selectedDataCenters.split(",")))?.map(
                (obj, index) => (
                  <Chip
                    className={"chip"}
                    key={"chip" + index + "c"}
                    label={obj}
                    style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                  />
                )
              )}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllDataCenter(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmDialog
          size={"sm"}
          IsOpen={isOpenDeleteConfirmationPanel}
          Message={getToolTipText(
            getToolTip?.filter(x => x.LabelType === "Popup Message") || [],
            TOOLTIP_LABEL.DELETE
          )}
          OnHandelClick={this.deleteHSEObservation}
          AgreeText={getToolTipText(getToolTip, TOOLTIP_LABEL.YES)}
          DisAgreeText={getToolTipText(getToolTip, TOOLTIP_LABEL.NO)}
          deleteConfig={{
            id: "reasonForDelete",
            value: reasonForDelete,
            isDeleteReason: true,
            action: this.handleChange,
            name: getToolTipText(getToolTip, TOOLTIP_LABEL.REASON_FOR_DELETE)
          }}
        />
      </div>
    );
  }
}

export default HealthTable;
